import { RetryButton } from "./AdminUi";

const missingLabels = {
  invoice: "فاتورة التطبيق",
  order: "المنتجات قبل التغليف",
  both: "الطلب المغلف + الفاتورة",
  courier: "جوال المندوب",
};

export default function AdminSummary({
  summary = {},
  loading,
  error,
  onRetry,
}) {
  const stats = [
    ["إجمالي الطلبات", summary.total || 0],
    ["مكتملة", summary.complete || 0],
    ["نسبة الاكتمال", `${summary.completionRate || 0}%`],
    ["قيد التوثيق", summary.pending || 0],
    ["مرفوضة", summary.rejected || 0],
    ["ملغاة من التطبيق", summary.cancelled || 0],
    ["لم يستلمها المندوب", summary.courierNotPickedUp || 0],
    ["طلبات محذوفة", summary.deleted || 0],
  ];
  if (loading) return <div className="admin-empty">جاري تحميل الملخص…</div>;
  if (error)
    return (
      <div className="admin-empty admin-error">
        {error}{" "}
        <RetryButton onClick={onRetry} />
      </div>
    );
  return (
    <>
      <div className="admin-analytics">
        {stats.map(([label, value]) => (
          <div className="admin-stat" key={label}>
            <span>{label}</span>
            <b>{value}</b>
          </div>
        ))}
      </div>
      <div className="admin-insights">
        <div className="admin-insight">
          <span>طلبات اليوم</span>
          <b>{summary.today || 0}</b>
          <small>جميع المطاعم</small>
        </div>
        <div className="admin-insight">
          <span>آخر 7 أيام</span>
          <b>{summary.last7Days || 0}</b>
          <small>الطلبات المسجلة</small>
        </div>
        <div className="admin-insight">
          <span>أكثر تطبيق في تقرير الأخطاء</span>
          <b>{summary.topApp?.name || "—"}</b>
          <small>{summary.topApp?.count || 0} طلب</small>
        </div>
        <div className="admin-insight">
          <span>أكثر فرع في تقرير الأخطاء</span>
          <b>{summary.topBranch?.name || "—"}</b>
          <small>{summary.topBranch?.count || 0} طلب</small>
        </div>
        <div className="admin-insight">
          <span>أكثر صورة مطلوبة ناقصة</span>
          <b>{missingLabels[summary.missingPhoto?._id] || "—"}</b>
          <small>{summary.missingPhoto?.count || 0} طلب</small>
        </div>
        <div className="admin-insight">
          <span>نسبة المطابقة</span>
          <b>{summary.matchRate || 0}%</b>
          <div className="admin-bar">
            <i style={{ width: `${summary.matchRate || 0}%` }} />
          </div>
        </div>
      </div>
    </>
  );
}
